// extracted by mini-css-extract-plugin
module.exports = {"container":"HistoryPartners_container__3xihU","coverImg":"HistoryPartners_coverImg__3hZLD","title":"HistoryPartners_title__1BSv4","content":"HistoryPartners_content__26ZzO"};